// extracted by mini-css-extract-plugin
export default {"paginatorContainer":"Paginator_paginatorContainer__7t8Gf","paginatorItem":"Paginator_paginatorItem__kZ2pE","isActive":"Paginator_isActive__fcA8H"};